import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ReportIcon from '@mui/icons-material/Report';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import useReportError from '../../../../../hooks/errorsHooks/useReportError';
import { useSelector } from 'react-redux';
import { actionSectionIdentifier, sectionIdentifier, statusAction } from '../../../../../constants/ticketsErrors';
import { useSnackbar } from 'notistack';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import useTickets from '../../../../../hooks/ticketsHook/useTickets';
import FormTicket from './FormTicket';
import { Icon } from '@iconify/react';
import BugReportIcon from '@mui/icons-material/BugReport';

export default function DialogReportTicket({ buttonType = 'normal', ticketObj = {} }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      {buttonType === 'menuItem' && (
        <MenuItem onClick={() => setOpenDialog(true)} sx={{ typography: 'body2', py: 1, px: 2.5 }}>
          <Box
            component={Icon}
            icon="eva:alert-circle-fill"
            sx={{
              mr: 2,
              width: 24,
              height: 24
            }}
          />
          Abrir ticket
        </MenuItem>
      )}

      {buttonType === 'icon' && (
        <Tooltip title="Abrir ticket">
          <IconButton color="error" onClick={() => setOpenDialog(true)}>
            <Typography>Reportar el problema</Typography>
            <BugReportIcon />
          </IconButton>
        </Tooltip>
      )}

      {buttonType === 'normal' && (
        <Button
          sx={{ textTransform: 'initial' }}
          color="warning"
          variant="contained"
          onClick={() => setOpenDialog(true)}
        >
          Abrir ticket
        </Button>
      )}
      {/* <Tooltip title="Reportar error">
        <IconButton color="error" size="small" onClick={() => setOpenDialog(true)}>
          <ReportIcon />
        </IconButton>
      </Tooltip> */}

      <DialogTicketForm open={openDialog} onClose={setOpenDialog} ticketObj={ticketObj} />
    </>
  );
}

function DialogTicketForm({ open, onClose, ticketObj = {} }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <FormTicket handleClose={handleClose} ticketObj={ticketObj} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
